/**
 * Client-safe constants for signed form and hotel links. The token module itself
 * (`signed-link-token.ts`) is server-only; anything a client file needs to know about
 * a link (which query param carries it, how to tell a signed token from a legacy one)
 * lives here so no `"use client"` file ever imports the signing code.
 */

/** Query param that carries a form or hotel link token (`?e=`), signed or legacy. */
export const SIGNED_LINK_PARAM = "e";

/** Every signed link token starts with this version prefix; legacy `?e=` tokens never do. */
export const SIGNED_LINK_VERSION_PREFIX = "v2.";

/** Days a form link stays valid after the form's `closes_at`. */
export const FORM_LINK_DAYS_AFTER_CLOSE = 30;

/** Days a hotel link stays valid after the booking link's main checkout date. */
export const HOTEL_LINK_DAYS_AFTER_CHECKOUT = 7;

/** Lifetime of a form or hotel link when there is no close or checkout date to anchor it. */
export const DEFAULT_LINK_LIFETIME_DAYS = 180;

/** Fresh-link emails one address may receive per hour. */
export const FRESH_LINK_MAX_PER_ADDRESS_PER_HOUR = 3;

/** Fresh-link requests one IP may make per hour. */
export const FRESH_LINK_MAX_PER_IP_PER_HOUR = 20;

/**
 * Shown after every fresh-link request, whether or not a response exists, so the
 * button never reveals who has answered a form or booked a room.
 */
export const FRESH_LINK_SENT_MESSAGE =
  "If we have an answer or booking for this email, we just sent a fresh link to it. Check your inbox.";

/** Shown when a fresh-link request is rate limited. */
export const FRESH_LINK_RATE_LIMITED_MESSAGE = "Too many requests. Please wait a while and try again.";
